/* eslint-disable react/prop-types */
import React from 'react';
import Loader from './Loader';
import Image from './Image';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-currency-format';

/**
 *
 * @param props.label
 * @param props.value
 * @param props.discount
 * @param props.startingAt
 * @param {boolean} props.isHeaderPrice
 * @param {boolean} props.isSummaryPrice
 * @param {boolean} props.isWarrantyPrice
 * @param {boolean} props.isGVPPrice
 * @param {boolean} props.isTreatmentPrice
 * @param {boolean} props.isInsuranceEnabled
 * @param {boolean} props.isInsuranceLoading
 * @param props.showInsurancePrice
 */
const Price = props => {
    const labels = useSelector(state => state.main.labels);
    const currencyFormat = useSelector(state => state.main.currencyFormat);
    const baseURLs = useSelector(state => state.main.baseURLs);

    const value = parseFloat(props.value);
    const discount = parseFloat(props.discount);

    const renderPrice = value => {
        return (
            <NumberFormat
                value={value}
                displayType={'text'}
                prefix={currencyFormat.suffix ? '' : currencyFormat.prefix}
                suffix={currencyFormat.suffix}
                decimalSeparator={currencyFormat.decimalSeparator}
                thousandSeparator={currencyFormat.thousandSeparator}
                decimalScale={2}
                fixedDecimalScale={true}
                renderText={value => <>{value}</>}
            />
        );
    };

    return (
        <>
            {/* GVP price header */}
            {props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceEnabled &&
                !props.isInsuranceLoading &&
                !props.isTreatmentRecapPrice && (
                    <>
                        <div className="price-gvp-header">
                            <Image
                                imageClass="price-gvp-icon"
                                url={baseURLs.genericImage}
                                fileName="gvp-icon"
                                alt={labels.price.gvp}
                            />
                            <span className="price-gvp-title">{labels.price.gvp}</span>
                        </div>
                    </>
                )}

            <div
                className={
                    'price-container' +
                    (props.isSummaryPrice ? ' summary-price' : '') +
                    (props.isGVPPrice && !props.isInsuranceEnabled && !props.isInsuranceLoading
                        ? ' price-gvp-container'
                        : '')
                }
            >
                {/* Insurance loading label with loader */}
                {props.isInsuranceLoading && !props.isWarrantyPrice ? (
                    <>
                        <span className="label">{props.label}</span>
                        <Loader />
                    </>
                ) : null}

                {/* Header/summary label */}
                {(props.isHeaderPrice || props.isSummaryPrice) &&
                !props.startingAt &&
                !props.isInsuranceLoading ? (
                    <span className="label">{props.label}</span>
                ) : null}

                {/* Starting at label / Complete pair starting at label */}
                {props.startingAt &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice &&
                !props.isInsuranceLoading ? (
                    <span className={'label' + (props.isInsuranceEnabled ? ' insurance' : '')}>
                        {props.isGVPPrice && !props.isInsuranceEnabled
                            ? labels.price.completePair + '' + labels.price.startingAt.toLowerCase()
                            : labels.price.startingAt}
                    </span>
                ) : null}

                {/* Complete pair at label (treatments only) */}
                {props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceEnabled &&
                !props.isInsuranceLoading &&
                props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <span className="label">{labels.price.completePairAt}</span>
                ) : null}

                {/* Header price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        {discount > 0 && props.isInsuranceEnabled && (
                            <span className={'strike-price insurance'}>{renderPrice(value)}</span>
                        )}
                        <span
                            className={
                                'price' + (props.isInsuranceEnabled ? ' insurance-price' : '')
                            }
                        >
                            {props.discount !== undefined && props.discount !== null
                                ? renderPrice(discount > 0 ? value - discount : value)
                                : renderPrice(value)}
                        </span>
                    </div>
                ) : null}

                {/* Step button price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.discount !== undefined &&
                props.discount !== null &&
                !props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        {discount > 0 && (
                            <span
                                className={
                                    'strike-price' + (props.isInsuranceEnabled ? ' insurance' : '')
                                }
                            >
                                {renderPrice(value)}
                            </span>
                        )}
                        <span
                            className={
                                'price' + (props.isInsuranceEnabled ? ' insurance-price' : '')
                            }
                        >
                            {renderPrice(discount > 0 ? value - discount : value)}
                        </span>
                    </div>
                ) : null}

                {/* Step button GVP price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.discount !== undefined &&
                props.discount !== null &&
                props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceEnabled &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        <span className="price">
                            {renderPrice(discount > 0 ? value - discount : value)}
                        </span>
                    </div>
                ) : null}

                {/* Treatment price (delta) */}
                {props.value !== undefined &&
                props.value !== null &&
                !props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        {!props.isInsuranceEnabled ||
                        (props.isInsuranceEnabled && props.showInsurancePrice) ? (
                            <span
                                className={
                                    'price treatment' +
                                    (value == 0 ? ' included-treatment' : '') +
                                    (props.isInsuranceEnabled ? ' insurance-price' : '')
                                }
                            >
                                {value == 0 ? (
                                    <>{labels.price.free}</>
                                ) : (
                                    <>
                                        {value > 0 ? '+' : '-'}
                                        {renderPrice(Math.abs(value))}
                                    </>
                                )}
                            </span>
                        ) : null}
                    </div>
                ) : null}

                {/* Treatment GVP price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceEnabled &&
                !props.isInsuranceLoading &&
                props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        <span className="price">{renderPrice(value)}</span>
                    </div>
                ) : null}

                {/* Treatment recap price (delta) */}
                {props.value !== undefined &&
                props.value !== null &&
                !props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        <span
                            className={
                                'price' + (props.isInsuranceEnabled ? ' insurance-price' : '')
                            }
                        >
                            {value !== 0 && (
                                <>
                                    {value > 0 ? '+' : '-'}
                                    {renderPrice(Math.abs(value))}
                                </>
                            )}
                        </span>
                    </div>
                ) : null}

                {/* Treatment recap GVP price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.isGVPPrice &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceEnabled &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        <span className="price">{renderPrice(parseFloat(value))}</span>
                    </div>
                ) : null}

                {/* Warranty price */}
                {props.value !== undefined &&
                props.value !== null &&
                !props.isHeaderPrice &&
                !props.isSummaryPrice &&
                props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        <span className="price">{renderPrice(parseFloat(value))}</span>
                    </div>
                ) : null}

                {/* Summary price */}
                {props.value !== undefined &&
                props.value !== null &&
                props.discount !== undefined &&
                props.discount !== null &&
                !props.isHeaderPrice &&
                props.isSummaryPrice &&
                !props.isWarrantyPrice &&
                !props.isInsuranceLoading &&
                !props.isTreatmentPrice &&
                !props.isTreatmentRecapPrice ? (
                    <div className="price-inner-container">
                        {discount > 0 && (
                            <span
                                className={
                                    'strike-price' + (props.isInsuranceEnabled ? ' insurance' : '')
                                }
                            >
                                {renderPrice(value)}
                            </span>
                        )}
                        <span
                            className={
                                'price' + (props.isInsuranceEnabled ? ' insurance-price' : '')
                            }
                        >
                            {renderPrice(discount > 0 ? value - discount : value)}
                        </span>
                    </div>
                ) : null}
            </div>
        </>
    );
};

export default Price;
